import { render, staticRenderFns } from "./ParcellesView.vue?vue&type=template&id=442c2b02"
import script from "./ParcellesView.vue?vue&type=script&lang=js"
export * from "./ParcellesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports